<template>
    <div ref="typeList" class="typeList">
        <div style="width: 100%"
            v-for="(item1,index1) in newForm"
            :key="index1"
            class="common-txt"
        >
            <div class="title-box" @click="handleSelectTitle(index1)" >
                <!--<p class="type-name"-->
                   <!--:class="{'active': newSelected.includes(index1)}"-->
                <!--&gt;-->
                    <!--<span class="name">{{item1.title}}</span>-->
                    <!--<span class="iconfont icon-xuanze_xianxing_xiala"></span>-->
                <!--</p>-->
            </div>
            <div
                v-if="index1 === 0"
                class="item-box"
                :class="{
                    'show': newSelected.includes(index1),
                    'noData': item1.data.length === 0
                }"
                :style="`
                    ${!isLastPage?'min-height:'+minHeight+'px;': ''}
                `"
            >
                <div class="blank-box" v-if="item1.data.length === 0">
                    <img class="img" :src="$images.global.blank" alt="img" />
                    <span class="word">暂无数据</span>
                </div>
                <div
                        class="item"
                        :style="type==='template'?`width: calc(100% - 2px);`:`width: 48%;`"
                        v-for="(item,index) in item1.data"
                        :key="index"
                >
                    <VideoItem
                        v-if="type==='video'"
                        :index.sync="index"
                        :url.sync="item.url"
                        :item.sync="item"
                        @click.native="handleSelectItem(item)"
                        @handleSelect="handleSelect"
                        @handleOut="handleOut"
                        @play="play"
                        @stop="stop"
                        @onBackground="$emit('onBackground', item, 'backgroundVideo')"
                    />
                    <TemplateItem
                        v-else-if="type==='template'"
                        :item.sync="item"
                        :isPlat=isPlat
                        @onSelect="handleSelectItem(item)"
                    />
                    <CompImgBox
                        v-else
                        :item="item"
                        :isBackground="isBackground"
                        @onBackground="handleSetBackground(item)"
                        @onSelect="handleSelectItem(item)"
                        @onMouseenter.stop="handleSelect(item, $event)"
                        @onMouseleave.stop="handleOut($event)"
                    />
                </div>
                <p v-if="isLastPage && item1.data.length" class="last-info">{{$enums.configInfo.moreInfo}}</p>
                <!--<p class="item more"-->
                   <!--v-if="item1.page && item1.last_page && item1.page<item1.last_page"-->
                   <!--:style="item1.column?`width:${100/item1.column-4}%;margin-right:4%;`:`` "-->
                   <!--@click.stop="handleMore(item1)"-->
                <!--&gt;<span class="sp-more">更多展示</span></p>-->
            </div>
        </div>
        <div class="pre-box"
             :style="`right: ${position.x}px;top: ${position.y}px`"
             :class="{show: isShowPre}"
        >
            <video v-if="type==='video' && curMaterial"
                   crossOrigin="anonymous"
                   ref="video"
                   class="curImg"
                   autoplay="autoplay"
                   :src="isShowPre?curMaterial:''"
            >
            </video>
            <p v-else class="img-box">
                <span class="sp-img">
                    <img crossorigin="anonymous" class="curImg" :src="curMaterial?curMaterial:((curMaterial && curMaterial.cover) || $images.default)" alt="curImg" />
                </span>
            </p>
            <div class="curName">
                <span class="name">{{curName}}</span>
                <Tips
                    :type="type"
                    :data="[
                        {name: '线上', type: 'on-line', show: curItem.is_online},
                        {name: '线下', type: 'off-line', show: curItem.is_offline},
                        {name: '答题器', type: 'double', show: curItem.is_double_teacher},
                        {name: '课后', type: 'exercise', show: curItem.is_exercise}
                    ]"
                />
            </div>
            <p class="line"></p>
            <p class="remark">{{curItem.description}}</p>
        </div>
        <WarnInfo
            :isWarnInfo.sync="isWarnInfo"
            :loading.sync="isLoadingSubmit"
            :type="type"
            @success="submit"
        />
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import VideoItem from './components/video'
    import Tips from '../tips'
    import TemplateItem  from './components/template'
    import WarnInfo from './components/warnInfo'
    //import * as commonServer from '../../../../../../../../api/common'
    export default {
        name: "type-list",
        components: {
            VideoItem,
            Tips,
            TemplateItem,
            WarnInfo
        },
        props: {
            minHeight: [Number, String],
            isBackground:{
                type: Boolean,
                default: false
            },
            form: {
                type: Array
            },
            selected: {
                type: Array
            },
            type: String,
            loading: {
                type: Boolean,
                default: false
            },
            isPlat: {
                type: Boolean,
                default: false
            },
        },
        computed: {
            ...mapState(['menusData']),
            getFormList(){
                return 'getFormList'
            },
            isLastPage(){
                let state = false
                try {
                    const data = this.$_.cloneDeepWith(this.newForm)
                    const item1 =  data[0]
                    state = item1.page && item1.last_page && item1.page >= item1.last_page
                } catch (e) {
                    console.log('获取isLastPage==>', e)
                }
                return state
            }
        },
        watch: {
            form(vl){this.newForm = vl},
            newForm(vl){this.$emit('update:form', vl)},
            selected(vl){this.newSelected = vl},
            newSelected(vl){this.$emit('update:selected', vl)},
            type(vl){this.newType = vl},
            newType(vl){this.$emit('update:type', vl)},
            loading(vl){this.isLoading = vl},
            isLoading(vl){this.$emit('update:loading', vl)},
            isShowPre(vl){
                if(vl){
                    $eventBus.$emit('onCocosDisabled', true)
                } else {
                    $eventBus.$emit('onCocosDisabled', false)
                }
            }
        },
        created(){
            window.addTwo = ()=>{
                this.handleSetBackground(this.newForm[0].data[0])
            }
            window.addGO = (num)=>{
                let c = num
                 const fn = ()=>{
                     if(c>0){
                        setTimeout(() => {
                            addOne()
                            setTimeout(() => {
                                addTwo()
                                c--
                                fn()
                            }, 500)
                        })
                     }
                 }
                 fn()
            }
        },
        data(){
            return {
                isWarnInfo: false, // 确认弹窗
                isLoadingSubmit: false, // 当前是否正在确认
                fnNext: null, // 当确认点击后需要执行的事件回调

                isLoading: this.loading,
                newForm: this.form,
                newSelected: this.selected,
                newType: this.type,

                isShowPre: false, // 显示预览
                curItem: {}, // 当前素材所有字段
                curMaterial: '', // 当前展示素材
                curName: '', // 当前展示素材名称
                position: {
                    x: 400,
                    y: 250
                },
            }
        },
        methods: {
            submit(){
                const fn = setTimeout(()=>{
                    if(this.fnNext) {
                        this.fnNext()
                        this.fnNext = null
                    }
                    this.isLoadingSubmit = false
                    this.isWarnInfo = false
                    clearTimeout(fn)
                }, 100)
            },
            scrollTodo(){
                // 1.如果 滚动的距离 === 文本实际渲染高度【contentHeight】 - 浏览器可视高度【boxHeight】
                // 2.加载下一页
                if(
                    !this.isLastPage &&
                    !this.isLoading
                ){
                    this.isLoading = true

                    const fn = setTimeout(()=>{
                        this.handleMore(this.newForm[0])
                        this.isLoading = false
                        clearTimeout(fn)
                    }, 500)
                }
            },
            // 获取实际展示高度
            getCurHeight(item1){
                // let isMore = item1.page && item1.last_page && item1.page<item1.last_page
                // let more = isMore ? 2 : 0
                let height = 90
                if(['template'].includes(this.type)) height = 120
                return Math.ceil((item1.data.length)/item1.column) * height
            },
            getRealUrl(item){
                let url = ''
                if(item.url && typeof item.url === 'string') {
                    url = item.url
                } else if (item.cover && typeof item.cover === 'string') {
                    url = item.cover
                } else if (item.attributes && item.attributes.url && item.attributes.url === 'string') {
                    url = item.attributes.url
                } else if (item.attributes && item.attributes.cover && item.attributes.cover === 'string') {
                    url = item.attributes.cover
                }
                // url = this.$utils.getNewUrl(url)
                return url
            },
            play(){
                this.$refs.video && this.$refs.video.play()
            },
            stop(){
                this.$refs.video && this.$refs.video.pause()
            },
            // 更多
            handleMore(item){
                console.log('更多==>')
                this.$emit('onMoreTypeList', item)
            },
            // 类型1 收藏点击
            handleTypeOneLove(index1, index){
                this.newForm[index1].data[index].love = !this.newForm[index1].data[index].love

                this.$emit('onTypeList', this.newForm[index1].data[index], this.newForm[index1].data)
            },
            async handleSelectTitle(index1){
                console.log('选择标题==>')
                // 判断展开数据是否有数据，如果没有，请求数据
                if(this.newForm[index1].data.length === 0){
                    let config = this.newForm[index1].apiConfig
                    const data = await config.request(config.params)
                    let url = ''

                    this.newForm[index1].page = data.meta.current_page
                    this.newForm[index1].last_page = data.meta.last_page
                    let arr = data.items.map(q => {
                        url = q.attributes && q.attributes.resources && q.attributes.resources.url
                        if (q.attributes && q.attributes.cover) url = q.attributes.cover
                        if (q.attributes && q.attributes.h5_remote) url = q.attributes
                        return {
                            url,
                            ...q
                        }
                    })

                    // 如果是游戏，关联出场景
                    if(this.type === 'game'){
                        let newArr = []
                        let sesScene
                        for(let i = 0, len = arr.length; i < len; i++) {
                            /*sesScene = await commonServer.default[this.getFormList]({
                                page: 1,
                                categoryId: arr[i].form_category_id_scenes,
                                perPage: 6
                            })*/
                            sesScene=arr[i].form_category_scenes_list;

                            // 关联游戏中的第一个关联表单列表
                            this.newForm[index1].page = sesScene.meta.current_page
                            this.newForm[index1].last_page = sesScene.meta.last_page
                            //sesScene.items.map(q=>{
                            sesScene.map(q=>{
                                newArr.push({
                                    ...arr[i],
                                    form_id_scenes: q.id,
                                    alias: `${arr[i].alias}-${q.name}`,
                                    url: this.getImg(q.options)
                                })
                            })
                        }
                        arr = newArr
                    }

                    this.newForm[index1].data = arr
                }

                if(this.selected.includes(index1)){
                    this.selected.splice(this.selected.indexOf(index1), 1)
                }else{
                    this.selected.push(index1)
                }

                if(this.newForm[index1].data.length === 0){
                    // this.$message.error('该分类无数据')
                }
            },
            // 根据游戏配置获取图片
            getImg(str) {
                let url = ''
                try {
                    let obj = JSON.parse(str)
                    // console.log(obj)
                    // debugger
                    obj.layout.map(v=>{
                        if(v.config && v.config[0].attr === 'cover'){
                            url = v.config[0].value
                        }
                    })
                }catch (e) {
                    console.log('等待获取背景图==>', e)
                }
                return url
            },
            handleSelectItem(item1){
                if(this.$utils.isFastExecute(300)) return false
                console.log('优化速度==>选中素材', item1, this.type, 123)
                const isTemplate = ['template'].includes(this.type)
                // 正在保存不允许添加任何素材（游戏）
                if(this.$store.state.saving){
                    this.$message.warning('正在保存，请稍后')
                    return false
                }
                if(this.$store.state.isBuildCocos){
                    this.$message.warning('正在构建，请稍后')
                    return false
                }
                // 游戏环节判断是否支持添加
                if(!isTemplate && this.menusData.lessonSelectedConfig?.type === 'game' && this.type!=='game'){
                    this.$message.warning(this.$enums.warnType.game)
                    return false
                }
                // PPT环节判断是否支持添加
                if(!isTemplate && this.menusData.lessonSelectedConfig?.type === 'html' && this.type!=='game'){
                    this.$message.warning(this.$enums.warnType.ppt)
                    return false
                }
                let fn = ()=>{
                    if(this.type === 'animation' && item1.attributes.type === 'flash'){
                        this.$emit('onTypeList', item1, null, item1.attributes.type)
                        return false
                    }
                    this.$emit('onTypeList', item1)
                }
                if (['template'].includes(this.type)) {
                    this.isWarnInfo = true
                    this.fnNext = fn
                    // this.$confirm(`添加模版到课件, 是否继续?`, '提示', {
                    //     confirmButtonText: '确定',
                    //     cancelButtonText: '取消',
                    //     type: 'warning'
                    // }).then(() => {
                    //     fn()
                    // }).catch(() => {
                    // });
                    return false
                } else if (['scenes'].includes(this.type)){
                    this.isWarnInfo = true
                    this.fnNext = fn
                    // this.$confirm(`此操作将覆盖当前所有课程场景, 是否继续?`, '提示', {
                    //     confirmButtonText: '确定',
                    //     cancelButtonText: '取消',
                    //     type: 'warning'
                    // }).then(() => {
                    //     fn()
                    // }).catch(() => {
                    // });
                    return false
                }
                fn()
            },
            handleSetBackground(item){
                // 游戏环节判断是否支持添加
                if(this.menusData.lessonSelectedConfig?.type === 'game'){
                    this.$message.warning(this.$enums.warnType.game)
                    return false
                }
                // PPT环节判断是否支持添加
                if(this.menusData.lessonSelectedConfig?.type === 'html'){
                    this.$message.warning(this.$enums.warnType.ppt)
                    return false
                }
                this.$emit('onTypeListImage', item)
            },
            // 当前预览素材
            handleSelect (item, e) {
                console.log('鼠标移入==>')
                setImmediate(()=>{
                    const screenHeight= document.documentElement.clientHeight
                    const divHeight = document.querySelector('.typeList .pre-box').clientHeight
                    const minHeght = screenHeight - divHeight
                    console.log('handleSelect==>', screenHeight, divHeight)
                    this.curItem = item
                    this.curMaterial = item.url || item.cover
                    this.curName = item.alias || item.name
                    // console.log('鼠标移入==>', e)
                    const y = e.pageY - 80
                    this.position.y = (screenHeight - divHeight)<=y?minHeght:y

                    this.position.x = this.$refs.typeList.clientWidth + 120

                    this.isShowPre = true
                })

            },
            // 鼠标移除
            handleOut(){
                //console.log('鼠标移除==>')
                const fn = setImmediate(()=>{
                    this.isShowPre = false
                    //console.log('鼠标移除1==>', this.isShowPre)
                    clearImmediate(fn)
                })
            }
        },
        destroyed() {
            const div = document.querySelector('.content-txt')
            div.removeEventListener("scroll", this.scrollTodo)
        }
    }
</script>

<style lang="scss" scoped>
    .typeList{
        width: 100%;
        padding-bottom: 50px;
    }
    .pre-box{
        position: fixed;
        top: 0px;
        right: 0px;
        background-color: white;
        width:400px;
        background:rgba(255,255,255,1);
        border-radius: 4px;
        box-shadow:0px 2px 8px 0px rgba(0,0,0,0.15);
        text-align: center;
        transition: all .2s linear;
        opacity: 0;
        visibility: hidden;

        &.show{
            visibility: initial;
            opacity: 1;
            z-index: 101;
        }


        .curImg {
            min-width: 80px;
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
        }
        .img-box {
            display: flex;
            width: 100%;
            flex-direction: row;
            justify-content: center;
            margin-top: 20px;

            .sp-img {
                width: 360px;
                height: 223px;
                background-color: rgba(238,238,238,.6);
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 4px;
                overflow: hidden;
            }
        }

        .curName {
            text-align: left;
            font-size:16px;
            font-weight:500;
            color:rgba(48,49,51,1);
            line-height:22px;
            margin: 10px 20px;
            display: flex;
            flex-direction: row;
            align-items: center;
        }
        .line{
            width: calc(100% - 40px);
            height: 1px;
            background-color: #DDDDDD;
            margin: 20px;
        }
        .remark{
            font-size: 14px;
            text-align: left;
            font-weight: 400;
            color: #95989E;
            line-height: 20px;
            margin: 12px 20px 10px;
            position: relative;
            top: -8px;
        }
    }
    .common-txt{
        .more{
            display: flex;
            width: 100%;
            justify-content: center;
            align-items: center;
            background-color: #F0F2F5;
            line-height: 40px;
            border-radius: 10px;
            cursor: pointer;

            &:active{
                opacity: .5;
            }
        }
    }
    .title-box{
        cursor: pointer;

        &:hover {
            /*background-color: #ff00ff;*/
        }
    }
    .type-name{
        font-size: 14px;
        width: 100%;
        color: #393500;
        border-radius: 10px;
        margin: 8px 0px;
        text-align: left;
        position: relative;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .iconfont{
            font-size: 12px;
            transform: scale(.6);
            transition: all .2s linear;
        }

        &.active{
            .iconfont {
                transform: scale(.6) rotateZ(-180deg);
            }
        }
    }
    .item-box{
        width: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        margin: 10px 0px;
        height: 0px;
        overflow: hidden;
        /*transition: all .2s linear;*/

        &.noData{
            margin-top: 50%;
        }

        .last-info{
            width: 100%;
            font-size: 14px;
            font-weight: 400;
            color: #656773;
            line-height: 60px;
            text-align: center;
        }

        .blank-box{
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            .img {
                display: flex;
                flex-shrink: 0;
            }
            .word {
                font-size: 14px;
                color: #656773;
                margin-top: 6px;
                position: relative;
                left: -2px;
            }
        }

        &.show{
            height: 100%;
            align-content: flex-start;
        }

        .item{
            width: 32%;
            margin-bottom: 10px;
            .img-box {
                width: 100%;
                height: 80px;
                position: relative;
                cursor: pointer;
                background: #F0F2F5;
                border-radius: 4px;

                .img-box-default {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    .default{
                        width: 100%;
                        height: 100%;
                    }
                }
                .txt-box {
                    position: absolute;
                    width: 100%;
                    /*height: 100%;*/
                    bottom: 0px;
                    left: 0px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;

                    .name {
                        background: rgba(0, 0, 0, 0.25);
                        font-size: 12px;
                        padding: 4px;
                        color: rgba(255, 255, 255, 0.85);
                        border-bottom-left-radius: 4px;
                        border-bottom-right-radius: 4px;
                    }
                }

                .set-bg{
                    position: absolute;
                    bottom: 4px;
                    right: 4px;
                    width: 18px;
                    height: 18px;
                    font-size: 12px;
                    color: #303133;
                    transition: all .2s linear;

                    .imgs-box{
                        width: 100%;
                        height: 100%;

                        .img {
                            border-radius: 0px !important;
                            &.active {
                                display: none !important;
                            }
                        }

                        &:hover{
                            /*background-color: #e7622e;*/

                            .img{
                                display: none !important;
                                &.active{
                                    display: inline-block !important;
                                }
                            }
                        }
                    }
                }
                .img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                    /*border-radius: 10px;*/
                }
                .love-box{
                    position: absolute;
                    top: 8px;
                    right: 8px;
                    cursor: pointer;

                    .img{
                        width: 20px;
                        height: 18px;
                    }
                }
            }
        }
    }
    .btn.more{
        font-size: 18px;
        background-color: #fed800;
        border-radius: 20px;
        border: none;
        color: #323232;
        margin-top: 10px;
        margin-bottom: 50px;
    }
    .item.more{
        height: 80px;
        border-radius: 4px;
    }
    .sp-more{
        width:66px;
        background:rgba(0,0,0,0.25);
        border-radius:15px;
        text-align: center;
        line-height: 26px;
        font-size: 12px;
        color: white;
    }
</style>
